import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber6 = () => {
  return (
    <g>
      <path d="m8.025 7.994a1.3285 1.3285 0 0 0 -1.3691 1.415 1.329 1.329 0 0 0 1.3691 1.415 1.3378 1.3378 0 0 0 1.4033-1.415 1.3373 1.3373 0 0 0 -1.4033-1.415z" />
      <path d="m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm.0826 11.7691a2.6606 2.6606 0 0 1 -2.3359-1.2187 4.5691 4.5691 0 0 1 -.6787-2.5664c0-2.4619 1.2539-4.1759 3.2676-4.1759a2.4 2.4 0 0 1 2.3809 1.4492l-1.0117.667a1.4185 1.4185 0 0 0 -1.3809-.9775c-1.2422 0-1.9326 1.22-1.9326 2.8418v.1953h.0342a1.9914 1.9914 0 0 1 1.9101-1.2658 2.3065 2.3065 0 0 1 2.4044 2.4514 2.5032 2.5032 0 0 1 -2.6574 2.5997z" />
    </g>
  );
};

export default withIcon(IconNumber6);
